import { render, staticRenderFns } from "./table.vue?vue&type=template&id=4b94d080&scoped=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"
import style0 from "./table.vue?vue&type=style&index=0&id=4b94d080&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b94d080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b94d080')) {
      api.createRecord('4b94d080', component.options)
    } else {
      api.reload('4b94d080', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=4b94d080&scoped=true", function () {
      api.rerender('4b94d080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/table/table.vue"
export default component.exports